import type { LocalPcfProgress } from '../../../shared/api/grpc/pcfExportCalculation';
import type { OperationProgressModel } from '../../../shared/ui/progress';

export function mapLocalPcfProgressToModel(
  progress: LocalPcfProgress,
  outputPath: string,
  requestedSystems: number,
): OperationProgressModel {
  const capture = progress.phase === 'capture';
  return {
    title: 'Exporting PCF files',
    message: capture
      ? '② Capturing Revit data in the PipeEX plugin…'
      : '② Calculating PCF files in the PipeEX plugin…',
    detail: capture
      ? 'Preparing the active Revit data for local calculation.'
      : `${progress.processed} of ${progress.total} piping groups processed locally.`,
    status: 'running',
    percent: progress.percent,
    processed: progress.processed,
    total: progress.total > 0 ? progress.total : null,
    locked: true,
    metrics: [
      { label: 'Requested systems', value: String(requestedSystems) },
      { label: 'Succeeded', value: String(progress.succeeded) },
      { label: 'Failed', value: String(progress.failed) },
      { label: 'Output folder', value: outputPath },
    ],
  };
}
